import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/use-auth';

export const usePlatformAdmin = () => {
  const { user, loading: authLoading } = useAuth();
  const [isPlatformAdmin, setIsPlatformAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkPlatformAdmin = async () => {
      if (!user || authLoading) {
        setIsPlatformAdmin(false);
        setLoading(false);
        return;
      }

      try {
        // Check if user exists in platform_admins table
        // Using maybeSingle() - returns null if no record found (no error)
        const { data: adminData, error: adminError } = await supabase
          .from('platform_admins')
          .select('is_active')
          .eq('user_id', user.id)
          .eq('is_active', true)
          .maybeSingle();

        if (adminError) {
          // Real error occurred (not just "no record found")
          console.error('Error checking platform admin status:', adminError);
          setIsPlatformAdmin(false);
        } else {
          // adminData will be null if no record found, or { is_active: true } if found
          setIsPlatformAdmin(!!adminData?.is_active);
        }
      } catch (error) {
        console.error('Error in platform admin check:', error);
        setIsPlatformAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkPlatformAdmin();
  }, [user, authLoading]);

  return { isPlatformAdmin, loading };
};
